export default {
  /**
   * @description 配置显示在浏览器标签的title
   */
  title: "大工匠官网",

  /** 公司名称 */
  name: "郑州市大工匠智能科技有限公司",
  /** 公司微信 */
  wechat: "19233735000",
  /** 公司邮箱 */
  email: "986399018@qq.com",
  /** 公司手机 */
  phone: "19233735000",
  /** 公司电话 */
  tel: "19233735000",
  /** 公司地址 */
  address:
    "河南省郑州市中原区中原西路街道中原西路北、华山路东中晟银泰国际中心B座25层2510号",
  /** 备案号 */
  keepOnRecordIcp: "豫ICP备2024074836号",

  /** 百度地图相关信息 */
  BDMapInfo: {
    longitude: 121.526896,
    latitude: 31.24022,
    title: "普联大厦",
    address:
      "河南省郑州市中原区中原西路街道中原西路北、华山路东中晟银泰国际中心B座25层2510号"
  }
};



// WEBPACK FOOTER //
// ./src/config/index.js